import type { NavigationGuard } from 'vue-router'

/**
 * Phones only. The 760px layout breakpoint is not used here: a narrow desktop
 * window keeps Create and the editor, while a phone stays unsupported in landscape.
 */
export function isMobileAvatarClient(userAgent = navigator.userAgent): boolean {
  return /iPhone|iPod|Android.*Mobile/i.test(userAgent)
}

/** Stop navigation before the creation flow or renderer can mount. */
export function createMobileAvatarGuard(isMobile: () => boolean, showNotice: () => void): NavigationGuard {
  return (to, from) => {
    const fallback = to.meta.desktopAvatarFallback
    if (!isMobile() || (fallback !== '/avatars/custom' && fallback !== '/avatars/library'))
      return

    showNotice()
    // Keep filters, pagination and scroll position on an in-app attempt.
    if (from.matched.length && from.meta.layout !== 'auth' && !from.meta.desktopAvatarFallback)
      return false

    // Bookmarks and login redirects need a usable collection behind the notice.
    return { path: fallback, replace: true }
  }
}
